<template lang="pug">
section
  .overlay
  header.d-flex.row.flex-row.align-items-end.justify-content-center.mb-5
    .col-12
      .absolute-right
      horizontal-stepper.mt-3(:steps='steps', :keep-alive="false", @completed-step='completeStep', locale='es', @active-step='isStepActive', @stepper-finished='finishPlan()')
</template>

<script>
import HorizontalStepper from 'vue-stepper'
import { mapActions } from 'vuex'
import moment from 'moment'

import ConsLiderAsig from './ps-consultor-lideresasigandos.vue'
import ConsDesarrolloPersonal from './ps-consultor-desarrollopersonal.vue'
import ConsResumen from './ps-consultor-resumen.vue'

export default {

  name: 'ConsultorPlanificacionSemanal',
  components: {
      HorizontalStepper
  },
  data () {
    return {      
      overlay: this.overlay,
      steps: [
        {
            name: 'liderasignado',
            title: 'Líderes asignados',
            component: ConsLiderAsig,
            completed: false,
        },
        {
            name: 'desarrollopersonal',
            title: 'Desarrollo personal',
            component: ConsDesarrolloPersonal,
            completed: false,
        },
        {
            name: 'resumen',
            title: 'Resumen',
            component: ConsResumen,
            completed: false,
        }
      ]
    }
  },
  methods: {
    ...mapActions('plan_con', [
      'closePlanificationStage'
    ]),        
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.steps.forEach((step) => {
          if (step.name === payload.name) {
              step.completed = true
              document.querySelector('.step-title').classList.add('state-past')
          }
      })
    },
    isStepActive(payload) {
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          if(step.completed === true) {
            step.completed = false
          }
        }
      })
    },
    finishPlan(payload) {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      vm.plan_con = vm.$store.getters['plan_con/getPlan']    
      vm.closePlanificationStage({id: vm.plan_con._id}).then((response) => {
        vm.$root.$emit('hidePlanificationCon', true);
        loading.hide()
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Planificación finalizada',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    if (vm.user.profile.name != 'Consultor') {
      vm.$router.replace({ path: '/permission' })
    }
    loading.hide()
  
  }
}
</script>



// WEBPACK FOOTER //
// src/views/consultor-planificacion-semanal.vue